import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Button, Checkbox, Input, Spin, useAlert } from './ui';
import { useSignIn } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Lock, Mail } from 'lucide-react';
import UpdatePassword from './UpdatePassword';
import UpdatePasswordAtFirstConnexion from './UpdatePasswordAtFirstConnexion';
import env from 'react-dotenv';
import datas from "../Assets/data.json"
import axios from 'axios';
import { Crypter } from '../Functions/Security/Crypter';
import Hash from '../Functions/Security/Hash';
import { saveSessionTokens, tokenExpiresInMinutes } from '../Functions/session';
import Logo from '../Assets/EBCallLogo.png';

export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

const LoginForm = (props: { codePromo?: string }) => {
    const navigat = useNavigate()
    const signIn = useSignIn()
    const alert = useAlert()

    const { register, handleSubmit, reset } = useForm()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [remember, setRemember] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [mustUpPass, setmustUpPass] = useState<boolean>(false)
    const [user, setUser] = useState<any>()

    const methods = useForm();

    const onSubmit = async (data: any) => {
        data.Pass = Hash(data.Pass)
        setmustUpPass(false)

        setLoading(true)
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Connexion,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(data))
        };
        axios.request(config)
            .then((response: any) => {
                setLoading(false)
                let res = JSON.parse(Crypter.decrypt(response.data)).Value

                if (res.StatutCode == 200) {
                    let user = res.Result[0][0];
                    reset()
                    if (user.IsFirstConnected) {
                        setUser(user)
                        setmustUpPass(true)
                    } else {

                        localStorage.setItem(datas.Habilitations, Crypter.encrypt(JSON.stringify(res.Result[1])))
                        saveSessionTokens(user)
                        if (signIn(
                            {
                                token: user.token,
                                expiresIn: tokenExpiresInMinutes(user),
                                tokenType: "Bearer",
                                authState: { "CodeU": user.CodeU, "Name": user.Name + " " + user.Prenom, "RoleId": user.RoleId, "CodeS": user.CodeS, "CodeFiliale": user.CodeFiliale, "Image": user.Image, "Group": user.RoleId, "CodeAbonne": user.CodeAbonne },
                            }
                        )) {
                            // Redirect or do-something
                            navigat("/")
                        } else {
                            alert.error("Une érreur s'est produit")
                        }
                    }

                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });
    }

    return (
        <FormProvider {...methods}>
            <div className="eb-login-card">
                <div className="eb-login-logo">
                    <img src={Logo} alt="eBCall" />
                </div>
                <h1 className="eb-login-title">Connectez vous à <b>eBCall</b></h1>
                <p className="eb-login-subtitle">Veuillez entrer vos identifiants.</p>

                <Spin spinning={loading}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="eb-login-label">Adresse email ou identifiant</div>
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("User")}
                            required
                            type='text'
                            placeholder="nom@exemple.com"
                            startIcon={<Mail size={18} />}
                        />
                        <div className="h-[18px]" />
                        <div className="eb-login-label">
                            <span>Mot de passe</span>
                            <UpdatePassword label='Oublié ?' />
                        </div>
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("Pass")}
                            required
                            type='password'
                            placeholder="••••••••"
                            startIcon={<Lock size={18} />}
                        />
                        <div className="h-1.5" />
                        <Checkbox
                            checked={remember}
                            onChange={setRemember}
                            label={<span className="text-[13px] text-[var(--eb-text-muted)]">Rester connecté</span>}
                        />
                        <div className="h-2.5" />
                        <Button
                            className="w-full"
                            variant='primary'
                            type='submit'
                            size='lg'
                            endIcon={<ArrowRight size={18} />}
                        >
                            Se connecter
                        </Button>
                    </form>
                </Spin>

                <div className="eb-login-footer">
                    © {new Date().getFullYear()} eBCall. Tous droits réservés. by <b>IBG-Alpha Tech</b>
                </div>
            </div>
            {mustUpPass ? <UpdatePasswordAtFirstConnexion reccord={user} /> : ''}
        </FormProvider>
    );
};

export default LoginForm;
